// Synchronous compatibility bridge for SVG output. Never a second live viewport.
let active = null;
const sourceNodeCounts = new WeakMap();
export const PLAN_CAPTURE_MAX_NODES = 250000;
let reservedNodes = 0;
export function getPlanCaptureContext() { return active; }
export function getPlanRenderTarget() {
  return active?.svg || globalThis.document?.getElementById('planSvg') || null;
}
export function withPlanCaptureTarget(svg, size, callback) {
  if (active) throw new Error('Nested plan capture is not supported');
  if (!svg || ![size?.w, size?.h].every(n => Number.isFinite(n) && n > 0 && n <= 16384)) throw new TypeError('Invalid capture target size');
  reservedNodes = 0;
  active = Object.freeze({ svg, size: Object.freeze({ ...size }) });
  try {
    const result = callback();
    if (result?.then) { Promise.resolve(result).catch(() => undefined); throw new TypeError('Plan capture must be synchronous'); }
    if (reservedNodes > PLAN_CAPTURE_MAX_NODES) throw new RangeError('Plan export exceeds SVG allocation budget');
    return result;
  } finally { active = null; }
}

// Conservative preallocation guard for Core primitives and shared imported SVG trees.
export function reservePlanCaptureNodes(count = 1) {
  if (!active) return;
  reservedNodes += count;
  if (reservedNodes > PLAN_CAPTURE_MAX_NODES) throw new RangeError('Plan export exceeds SVG allocation budget');
}
export function reservePlanCaptureAsset(root) {
  if (!active) return;
  let count = sourceNodeCounts.get(root);
  if (count === undefined) {
    const stack = [root]; count = 0;
    while (stack.length) {
      const node = stack.pop();
      if (++count > PLAN_CAPTURE_MAX_NODES) throw new RangeError('Imported SVG exceeds export node budget');
      for (const child of node.children || []) stack.push(child);
    }
    sourceNodeCounts.set(root, count);
  }
  reservePlanCaptureNodes(count + 10);
}
